"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = exports.CARD_KIND = void 0;

var _react = _interopRequireDefault(require("react"));

var _card = require("baseui/card");

var _propTypes = require("prop-types");

var _SIZE;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CARD_KIND = {
  poster: 'poster',
  thumbnail: 'thumbnail'
};
exports.CARD_KIND = CARD_KIND;
var SIZE = (_SIZE = {}, _defineProperty(_SIZE, CARD_KIND.poster, {
  small: {
    width: 150,
    height: 225
  },
  "default": {
    width: 200,
    height: 300
  }
}), _defineProperty(_SIZE, CARD_KIND.thumbnail, {
  small: {
    width: 150,
    height: 85
  },
  "default": {
    width: 200,
    height: 113
  }
}), _SIZE);

var getMinMediaQuery = function getMinMediaQuery(minWidth) {
  return "@media screen and (min-width: ".concat(minWidth, "px)");
};

var getMaxMediaQuery = function getMaxMediaQuery(maxWidth) {
  return "@media screen and (max-width: ".concat(maxWidth, "px)");
};

var Title = {
  style: function style(_ref) {
    var $theme = _ref.$theme;
    var breakpoints = $theme.breakpoints,
        colors = $theme.colors,
        typography = $theme.typography;
    var MQ_SMALL = getMaxMediaQuery(breakpoints.medium - 1);
    return _defineProperty({
      color: colors.mono100,
      textAlign: 'center'
    }, MQ_SMALL, _objectSpread({}, typography.font300));
  }
};
var Contents = {
  style: function style(_ref3) {
    var $theme = _ref3.$theme;
    return {
      marginTop: $theme.sizing.scale400,
      marginRight: $theme.sizing.scale600,
      marginBottom: $theme.sizing.scale200,
      marginLeft: $theme.sizing.scale600
    };
  }
}; // https://baseweb.design/components/card/
// https://github.com/uber/baseweb/tree/master/src/card

var Card = function Card(_ref4) {
  var children = _ref4.children,
      headerImage = _ref4.headerImage,
      kind = _ref4.kind,
      onClick = _ref4.onClick,
      title = _ref4.title,
      rest = _objectWithoutProperties(_ref4, ["children", "headerImage", "kind", "onClick", "title"]);

  var size = SIZE[kind];
  var Root = {
    style: function style(_ref5) {
      var $theme = _ref5.$theme;
      var breakpoints = $theme.breakpoints,
          colors = $theme.colors;
      var MQ_MEDIUM_UP = getMinMediaQuery(breakpoints.medium);
      return _objectSpread({}, onClick && {
        cursor: 'pointer'
      }, _defineProperty({
        backgroundColor: colors.primary,
        borderTopWidth: '0',
        borderRightWidth: '0',
        borderBottomWidth: '1px',
        borderLeftWidth: '0',
        borderColor: colors.primary,
        width: "".concat(size.small.width, "px")
      }, MQ_MEDIUM_UP, {
        width: "".concat(size["default"].width, "px")
      }));
    }
  };
  var HeaderImage = {
    style: function style(_ref6) {
      var $theme = _ref6.$theme;
      var breakpoints = $theme.breakpoints;
      var MQ_MEDIUM_UP = getMinMediaQuery(breakpoints.medium);
      return _defineProperty({
        width: "".concat(size.small.width, "px"),
        height: "".concat(size.small.height, "px")
      }, MQ_MEDIUM_UP, {
        width: "".concat(size["default"].width, "px"),
        height: "".concat(size["default"].height, "px")
      });
    }
  };
  return _react["default"].createElement(_card.Card, _extends({
    overrides: {
      Root: Root,
      HeaderImage: HeaderImage,
      Title: Title,
      Contents: Contents
    },
    onClick: onClick,
    headerImage: headerImage,
    title: title
  }, rest), children && _react["default"].createElement(_card.StyledBody, {
    $style: function $style(_ref8) {
      var $theme = _ref8.$theme;
      return {
        color: $theme.colors.mono600
      };
    }
  }, children));
};

exports.Card = Card;
Card.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]),
  headerImage: _propTypes.string,
  onClick: _propTypes.func,
  kind: _propTypes.string,
  title: _propTypes.node
};
Card.defaultProps = {
  children: undefined,
  headerImage: undefined,
  onClick: undefined,
  kind: CARD_KIND.poster,
  title: undefined
};